declare namespace $ {

	type $mol_link__hint_giper_baza_glob_book_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__arg_giper_baza_glob_book_2 = $mol_type_enforce<
		({ 
			'link': ReturnType< $giper_baza_glob_book['home_link'] >,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_giper_baza_glob_book_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_giper_baza_glob_book_4 = $mol_type_enforce<
		({ 
			'side': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_giper_baza_glob_book_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $giper_baza_land_page__land_giper_baza_glob_book_6 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['land'] >
		,
		ReturnType< $giper_baza_land_page['land'] >
	>
	type $giper_baza_land_page__pawn_giper_baza_glob_book_7 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['pawn'] >
		,
		ReturnType< $giper_baza_land_page['pawn'] >
	>
	type $giper_baza_land_page__tools_giper_baza_glob_book_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_baza_land_page['tools'] >
	>
	type $mol_check_box__checked_giper_baza_glob_book_9 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['land_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_pick__hint_giper_baza_glob_book_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__clicks_giper_baza_glob_book_11 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['wipe'] >
		,
		ReturnType< $mol_pick['clicks'] >
	>
	type $mol_pick__align_hor_giper_baza_glob_book_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align_hor'] >
	>
	type $mol_pick__trigger_content_giper_baza_glob_book_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_giper_baza_glob_book_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $giper_baza_land_grab__hint_giper_baza_glob_book_15 = $mol_type_enforce<
		string
		,
		ReturnType< $giper_baza_land_grab['hint'] >
	>
	type $giper_baza_land_grab__align_hor_giper_baza_glob_book_16 = $mol_type_enforce<
		string
		,
		ReturnType< $giper_baza_land_grab['align_hor'] >
	>
	type $giper_baza_land_grab__grab_giper_baza_glob_book_17 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['land_add'] >
		,
		ReturnType< $giper_baza_land_grab['grab'] >
	>
	type $mol_button_open__hint_giper_baza_glob_book_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open['hint'] >
	>
	type $mol_button_open__files_giper_baza_glob_book_19 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['update'] >
		,
		ReturnType< $mol_button_open['files'] >
	>
	type $mol_button_download__hint_giper_baza_glob_book_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['hint'] >
	>
	type $mol_button_download__enabled_giper_baza_glob_book_21 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['dump_enabled'] >
		,
		ReturnType< $mol_button_download['enabled'] >
	>
	type $mol_button_download__blob_giper_baza_glob_book_22 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['dump'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_giper_baza_glob_book_23 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['dump_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_link__arg_giper_baza_glob_book_24 = $mol_type_enforce<
		({ 
			'side': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_giper_baza_glob_book_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $giper_baza_land_rights__land_giper_baza_glob_book_26 = $mol_type_enforce<
		ReturnType< $giper_baza_glob_book['land_current'] >
		,
		ReturnType< $giper_baza_land_rights['land'] >
	>
	type $mol_page__title_giper_baza_glob_book_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_giper_baza_glob_book_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_giper_baza_glob_book_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $giper_baza_glob_book extends $mol_book2_catalog {
		home_link( ): string
		Home_link_icon( ): $mol_icon_account
		Home_link( ): $mol_link
		land( id: any): $giper_baza_land
		pawn( id: any): $giper_baza_dict
		Rights_open_icon( ): $mol_icon_security
		Rights_open( ): $mol_link
		Land( id: any): $giper_baza_land_page
		land_checked( id: any, next?: boolean ): boolean
		Land_checked( id: any): $mol_check_box
		wipe( next?: any ): any
		Wipe_icon( ): $mol_icon_delete_forever
		Wipe_pick( ): $mol_pick
		land_add( next?: $giper_baza_rank_preset | null ): $giper_baza_rank_preset | null
		Land_add( ): $giper_baza_land_grab
		update( next?: readonly(any)[] ): readonly(any)[]
		Update( ): $mol_button_open
		dump_enabled( ): boolean
		dump( ): $mol_blob
		dump_name( ): string
		Dump( ): $mol_button_download
		Rights_close_icon( ): $mol_icon_close
		Rights_close( ): $mol_link
		land_current( ): $giper_baza_land
		Rights_form( ): $giper_baza_land_rights
		menu_title( ): string
		menu_tools( ): readonly(any)[]
		param( ): string
		Spread( id: any): ReturnType< $giper_baza_glob_book['Land'] >
		menu_item_content( id: any): readonly($mol_view)[]
		menu_foot( ): readonly(any)[]
		Rights_page( ): $mol_page
	}
	
}

//# sourceMappingURL=book.view.tree.d.ts.map